import { state } from './state'
import { AuthGetters, getters } from './getters'
import { Mutations, mutations } from './mutations'
import { Actions, actions } from './actions'
import {
  Store as VuexStore,
  DispatchOptions,
  CommitOptions,
  Module,
} from 'vuex';
import type { State } from './state';
import { RootState } from '@/store';
  
export { State };

export type AuthStore<S = State> = Omit<VuexStore<S>, 'getters' | 'commit' | 'dispatch'> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload?: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  // TODO: How to configure a module without any actions?
  dispatch<K extends keyof Actions>(
    key: K,
    payload?: Parameters<Actions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<Actions[K]>;
} & {
  getters: {
    [K in keyof AuthGetters]: ReturnType<AuthGetters[K]>
  };
};

export const store: Module<State, RootState> = {
  state,
  mutations,
  getters,
  actions,
};